import styled from '@emotion/styled';
import Colors from '../theme/colors';
import { Text6 } from './Text6';

export const Text7 = styled(Text6)`
  color: ${Colors.text_1};
`;
